import ApiService from "@/core/services/api.service";
// action types
export const GET_COMPANIES = "getCompanies";
export const GET_COMPANY = "getCompany";
export const GET_COMPANY_RUT_EMPRESA = "getCompanyRutEmpresa";
export const UPDATE_COMPANY = "updateCompany";

export const GET_COMPANIES_ACCOUNT = "getCompaniesAccount";
export const GET_COMPANY_ACCOUNT = "getCompanyAccount";
export const DELETE_COMPANY_ACCOUNT = "deleteCompanyAccount";
export const CREATE_COMPANY_ACCOUNT = "createCompanyAccount";
export const UPDATE_COMPANY_ACCOUNT = "updateCompanyAccount";
export const GET_COMPANIES_NOTIFICATION = "getCompaniesNotification";
export const CREATE_NOTIFICATIONS = "createNotifications";
export const DELETE_COMPANY_NOTIFICACION = "deleteCompanyNotificacion";
export const CREATE_COMPANY_NOTIFICACION = "createCompanyNotificacion";
export const UPDATE_COMPANY_NOTIFICACION = "updateCompanyNotificacion";

export const DELETE_COMPANY = "deteleCompany"
// mutation types
export const SET_COMPANIES = "setCompanies";
export const SET_COMPANY = "setCompany";
export const SET_COMPANIES_NOTIFICATION = "setCompaniesNotification";
export const SET_COMPANIES_ACCOUNT = "setCompaniesAccount";
export const SET_COMPANY_ACCOUNT = "setCompanyAccount";

export const SET_ERROR = "setError";

const state = {
  errors: [],
  companies: [],
  companyClient: {},
  companiesAccount:[],
  companiesNotification:[],
  companyAccount:{}
};

const actions = {
  [GET_COMPANIES](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/Empresa/v1/empresas`}, '')
        .then(({ data }) => {
          context.commit(SET_COMPANIES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_COMPANY_RUT_EMPRESA](context, rutEmpresa) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/Empresa/v1/empresa/rutEmpresa/${rutEmpresa}`}, '')
        .then(({ data }) => {
          context.commit(SET_COMPANY, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_COMPANY](context, tokenEmpresa) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/Empresa/v1/empresa/${tokenEmpresa}`}, '')
        .then(({ data }) => {
          context.commit(SET_COMPANY, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },

  [UPDATE_COMPANY](context, company) {
    return new Promise((resolve, reject) => {
    ApiService.put({action:`/api/Empresa/v1/empresa/${company.tokenEmpresa}`}, company)
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },

  [DELETE_COMPANY](context, tokenEmpresa) {
    return new Promise((resolve, reject) => {
    ApiService.delete({action:`/api/Empresa/v1/empresa/${tokenEmpresa}`}, '')
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },

  [GET_COMPANIES_ACCOUNT](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/EmpresaConvenio/v1/empresas`}, '')
        .then(({ data }) => {
            console.log(JSON.stringify(data));
          context.commit(SET_COMPANIES_ACCOUNT, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_COMPANIES_NOTIFICATION](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/Empresa/v1/notificaciones`}, '')
        .then(({ data }) => {
          context.commit(SET_COMPANIES_NOTIFICATION, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_COMPANY_ACCOUNT](context, codigoEmpresa) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/EmpresaConvenio/v1/empresa/${codigoEmpresa}`}, '')
        .then(({ data }) => {
          context.commit(SET_COMPANY_ACCOUNT, data);
          console.log('retorna compania' + JSON.stringify(data));
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [CREATE_COMPANY_ACCOUNT](context, company) {
    return new Promise((resolve, reject) => {
    ApiService.setHeader();
    ApiService.post({action:`/api/EmpresaConvenio/v1/empresa/`}, company)
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  [UPDATE_COMPANY_ACCOUNT](context, company) {
    return new Promise((resolve, reject) => {
    ApiService.put({action:`/api/EmpresaConvenio/v1/empresa/${company.codigoEmpresa}`}, company)
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  [DELETE_COMPANY_ACCOUNT](context, codigoEmpresa) {
    return new Promise((resolve, reject) => {
    ApiService.delete({action:`/api/EmpresaConvenio/v1/empresa/${codigoEmpresa}`}, '')
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  [CREATE_NOTIFICATIONS](context, data) {
    return new Promise((resolve, reject) => {
    ApiService.setHeader();
    
    ApiService.post({action:`/api/Empresa/v1/Empresa/notificaciones/`}, data)
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('enviando ' + response);
          reject(response);
        });
    });
  },

  [CREATE_COMPANY_NOTIFICACION](context, company) {
    return new Promise((resolve, reject) => {
    ApiService.setHeader();
    ApiService.post({action:`/api/Empresa/v1/empresa/notificacion`}, company)
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  [UPDATE_COMPANY_NOTIFICACION](context, company) {
    return new Promise((resolve, reject) => {
    ApiService.put({action:`/api/Empresa/v1/empresa/notificacion/${company.rutEmpresa}}`}, company)
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  [DELETE_COMPANY_NOTIFICACION](context, company) {
    return new Promise((resolve, reject) => {
    ApiService.delete({action:`/api/Empresa/v1/empresa/notificacion/${company.rutEmpresa}/${company.email}`}, '')
    .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          // context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },

};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_COMPANIES](state, data) {
    state.error = {};
    state.companies = data;
  },
  [SET_COMPANY](state, data) {
    state.error = {};
    state.companyClient = data;
  },
  [SET_COMPANIES_ACCOUNT](state, data) {
    state.error = {};
    state.companiesAccount = data;
  },
  [SET_COMPANIES_NOTIFICATION](state, data) {
    state.error = {};
    state.companiesNotification = data;
  },
  [SET_COMPANY_ACCOUNT](state, data) {
    state.error = {};
    state.companyAccount = data;
  },
};

export default {
  state,
  actions,
  mutations
};
